import React, { useState } from 'react';
import type { RouteComponentProps } from 'react-router';

// Components
import SharedBudgetDrawerFooter from 'components/manage/budget/BudgetDrawer/SharedBudgetDrawerFooter';

// Utils
import { handleBudgetRouteChange, useLeaveBudgetRoute } from 'components/manage/budget/routes';

// Styles
import { DrawerTitle } from 'components/common/zolaUI/Drawer';
import { Container } from './BudgetGroupAddOrEdit.styles';

type RouteParams = {
  groupUuid?: string;
};

export type BudgetGroupAddOrEditProps = RouteComponentProps<RouteParams, RouteParams>;

const BudgetGroupAddOrEdit = ({
  params: { groupUuid },
  route,
  router: { setRouteLeaveHook },
}: BudgetGroupAddOrEditProps): JSX.Element => {
  const isEdit = !!groupUuid;
  const [isSubmitting] = useState(false);

  useLeaveBudgetRoute(route, setRouteLeaveHook);

  const handleCancel = () => {
    handleBudgetRouteChange('/settings');
  };

  const handleSave = () => undefined;

  return (
    <Container data-testid="BudgetGroupAddOrEdit">
      <DrawerTitle>{isEdit ? 'Edit' : 'New'} group</DrawerTitle>
      <SharedBudgetDrawerFooter
        handleCancel={handleCancel}
        handleSave={handleSave}
        cancelDisabled={isSubmitting}
        saveDisabled={isSubmitting}
      />
    </Container>
  );
};

export default BudgetGroupAddOrEdit;
